export const SELECTORS = {
  // Sitemap tab cards.
  PAGES_ONLY: 'PAGES_ONLY',
  WITH_META_TAGS: 'WITH_META_TAGS',
  // Crawler tab cards (OCT-5038): pages with the crawl options below the cards
  // (meta tags), or the same plus the page blocks the crawler infers from the
  // markup (OCT-4990). A sitemap import has no page markup, so no AI card there.
  STANDARD: 'STANDARD',
  WITH_BLOCKS: 'WITH_BLOCKS',
}
